export enum AuthorizationQuestionnaireItem {
  AUTHORIZATION = 'authorization',
  AUTHORIZATION_AUTHORIZATION = 'authorization/authorization',
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE = 'authorization/authorization/authorization-source',
  AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS = 'authorization/authorization/current-hours'
}
